import React, { useState, useEffect } from 'react';
import { ClipLoader } from 'react-spinners';

function Loader() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 20000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="loader__container">
      {isLoading && <p>loading model . . .  </p>}
      {!isLoading && <p>Model loaded successfully !</p>}
      <ClipLoader size='1.5rem' color="var(--color-light)" title='Loading ...' loading={isLoading} />
    </div>
  );
}

export default Loader;